var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99985 13C6.82977 13 4.01065 14.5306 2.21585 16.906C1.82956 17.4172 1.63641 17.6728 1.64273 18.0183C1.64761 18.2852 1.81521 18.6219 2.02522 18.7867C2.29704 19 2.67372 19 3.42708 19H16.5726C17.326 19 17.7027 19 17.9745 18.7867C18.1845 18.6219 18.3521 18.2852 18.357 18.0183C18.3633 17.6728 18.1701 17.4172 17.7839 16.906C15.9891 14.5306 13.1699 13 9.99985 13Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99985 10C12.4851 10 14.4999 7.98528 14.4999 5.5C14.4999 3.01472 12.4851 1 9.99985 1C7.51457 1 5.49985 3.01472 5.49985 5.5C5.49985 7.98528 7.51457 10 9.99985 10Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccount);
export default __webpack_public_path__ + "static/media/user-account.2a2f50f2c39694ccdf13580fb9012752.svg";
export { ForwardRef as ReactComponent };